module.exports =
  'app.box.com': '55a5d915446f517774210001'
  'appear.in': '55a5d915446f517774210000'
  'dropbox.com': '55a5d915446f517774210002'
  'evernote.com': '55a5d915446f517774210003'
  'github.com': '55a5d916446f517774210004'
  'docs.google.com': '55a5d916446f517774210006'
  'drive.google.com': '55a5d916446f517774210006'
  'hangouts.google.com': '55a5d916446f517774210007'
  'secure.helpscout.net': '55a5d917446f517774210008'
  'force.com': '55a5d917446f517774210009'
  'salesforce.com': '55a5d917446f517774210009'
  'slack.com': '55a5d917446f51777421000a'
  'twitter.com': '55a5d917446f51777421000b'
  'zendesk.com': '56940ede94fd60cf95f7ce6a'
  'join.me': '569411df90e3a6f655f73aaa'
  'getcorrello.com': '568c2b6c7d2758a55ac48c98'
  'fogbugz.com': '569d556febffd8769b0dc2ad'
  'surveymonkey.com': '568c143d95adcd7308cbc3fb'
  'publicate.it': '569d550d062c27feb4e6630c'
  'app.intercom.io': '56cdf5f7071f133a93eb2363'
  'app.screenful.me': '570262ea1100fa611d7e200a'
  'pipedrive.com': '57c72026e3248df11df6621b'
  'gmkr.io': '57dbc7dbc674083383e275a1'
  'moxtra.com': '57e02011fd209122a72e85c3'
  'includer.io': '57e22705114f96fa0aa532b0'
  'cl.ly': '583f81ec5f46b0887c236afc'
  'bitbucket.org': '588a331cc86ffbe08f5d2c67'
  'realtimeboard.com': '5893c2b56bde057070fbc1b7'
  'd.pr': '5894c177310f1e861bf12dc2'
  'gitlab.com': '596d1abf23be1b7ab89cf4c4'
  'figma.com': '59b2e7611e6ece0b35eac16a'
  'invisionapp.com': '596f2cb2d279152540b2bb31'
  'invis.io': '596f2cb2d279152540b2bb31'
  'freshdesk.com': '59764210fef8fa7830ddee68'
